export default __webpack_public_path__ + "static/media/referral-code.30346a25.jpg";